<template>
  <div class="yunxiao teacher open-ewallet">
    <div class="top-bg"></div>
    <div class="slogan-box">
      <div class="slogan" v-for="slogan of slogans" :key="slogan.title">
        <svg class="vxm-icon" aria-hidden="true">
          <use :xlink:href="'#' + slogan.menuIcon"></use>
        </svg>
        <div class="content">
          <div class="sub-title">{{slogan.title}}</div>
          <div class="details">{{slogan.details}}</div>
        </div>
      </div>
    </div>
    <div class="open-btn-wrapper">
      <van-button class="open-btn" square round block type="primary" @click="openEwallet()">立即开通电子钱包</van-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'eWalletOpen',
  data () {
    return {
      pageTitle: '开通电子钱包',
      slogans: [
        {
          title: '费用预存',
          details: '续费扩科更快捷',
          menuIcon: 'vxm-icon-bianzu2'
        },
        {
          title: '钱包支付',
          details: '钱包一键支付',
          menuIcon: 'vxm-icon-feiyongyucun'
        },
        {
          title: '数据统计',
          details: '钱包收支清晰',
          menuIcon: 'vxm-icon-shuju-xuanzhong1'
        },
      ]
    }
  },
  methods: {
    openEwallet () {
      this.showLoading();
      this.$api.companyWalletOpen()
      .then(res=> {
        if (res.code === 200) {
          this.$toast.success('电子钱包开通成功');
          this.$store.dispatch('queryUserInfo');
          if (this.$route.query.to) {
            this.$router.replace('/' + this.$route.query.to);
            return false;
          }          
          this.$router.back();
        }
        if (res.code > 60000) {
          this.$toast.fail(res.msg);
        }
      })
      .catch(err => {
        console.log(err)
      })
    }
  },
}
</script>

<style lang="scss" scoped>
.yunxiao.teacher.open-ewallet{
  background: var(--white);
  overflow: hidden;
  .top-bg{
    background: url(https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/00101.png);
    width: 100%;
    height: 0;
    padding-top: 95%;
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100%;
  }
  .open-btn-wrapper {
    padding: 0 calc(var(--gap) * 16);
  }
  .slogan-box {
    display: flex;
    .slogan{
      display: flex;
      flex-direction: column;
      flex: 1;
      align-items: center;
      text-align: center;
      margin: 0 calc(var(--gap) * 3) calc(var(--gap) * 32) calc(var(--gap) * 3);
      color: var(--g6);
      font-size:var(--fs-sm);
      line-height:var(--lh-sm);
      .sub-title{
        margin-bottom: calc(var(--gap) * 4);
        color: var(--g8);
        font-size:var(--fs-lg);
        line-height:var(--lh-lg);
        font-weight: var(--bold);
      }
      .vxm-icon {
        margin-bottom: calc(var(--gap) * 16);
        font-size: 30px;
      }
    }
  }
}
</style>